import React from 'react'
import { Button, Upload } from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import Text from 'antd/es/typography/Text'
import { useDispatch } from 'react-redux'
import { actions } from '../../../../../../../../store/reducers/unit-tests.reducer'
import { useParams } from 'react-router'
import { openNotificationWithIcon } from '../../../../../../../../utils/notification.helper'
import Access from '../../../../../../components/access/Access'
import { AssignmentPermissions } from '../../../../../../../../constants/assignment-permissions'

const extractFilenameFromPath = inputString => inputString.split('_').slice(1).join('_') //backend stores path like 'temporary-files/da0150f3-5089-4ea6-be94-7b56e66385d6_check_nl.zip' but we need to display only the filename 'check_nl.zip'

const TestFixtureFiles = ({
    fixtureFilesPath,
    setFixtureFilesPath,
    isWaitingForFixtureFilesUpload,
    setIsWaitingForFixtureFilesUpload,
}) => {
    const dispatch = useDispatch()
    const { token } = useParams()

    return (
        <Access
            permissions={[AssignmentPermissions.CAN_EDIT]}
            fallback={fixtureFilesPath ? extractFilenameFromPath(fixtureFilesPath) : null}
        >
            <label style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                <Text>Fixture files</Text>
                <Upload
                    showUploadList={false}
                    accept='.zip'
                    beforeUpload={async file => {
                        if (file.size / 1024 / 1024 > 25) {
                            openNotificationWithIcon('error', "File can't be bigger than 25MB")
                            return false
                        }
                        setIsWaitingForFixtureFilesUpload(true)
                        const newFixtureFilesPath = await dispatch(actions.uploadFixtureFiles(token, file))
                        setIsWaitingForFixtureFilesUpload(false)
                        if (newFixtureFilesPath) setFixtureFilesPath(newFixtureFilesPath)
                        return false
                    }}
                    aria-label='upload fixture files'
                >
                    <Button loading={isWaitingForFixtureFilesUpload} icon={<UploadOutlined />}>
                        Upload fixture files
                    </Button>
                </Upload>
            </label>
            {fixtureFilesPath && (
                <Text type='secondary'>
                    Current: {isWaitingForFixtureFilesUpload ? '...' : extractFilenameFromPath(fixtureFilesPath)}
                </Text>
            )}
        </Access>
    )
}

export default TestFixtureFiles
